export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7923.306d9bab.jpg";